export default __webpack_public_path__ + "static/3-54fe4ad67773e7164a9908d432ad525b.png";